<template>
	<v-row align="start" align-content="start" justify="start">
		<v-overlay :model-value="loading" class="align-center justify-center">
			<v-progress-circular color="primary" indeterminate size="64" />
		</v-overlay>

		<v-col v-if="!loading" cols="12" order="1">
			<paper-table training-queue-mode training />
		</v-col>
	</v-row>
</template>

<script>
import { mapActions } from "pinia";
import { useMainStore } from "@/store";

import PaperTable from "@/pages/PaperManager/PaperTable";

export default {
	name: "TrainingDashboard",

	components: {
		PaperTable,
	},

	data() {
		return {
			loading: false,
		};
	},

	computed: {
		paper() {
			return useMainStore().paper;
		},
		saveUUID() {
			return useMainStore().saveUUID;
		},
		user() {
			return useMainStore().user;
		},
	},

	created() {
		this.clear();
	},

	methods: {
		...mapActions(useMainStore, ["clearPaper", "clearSaveUUID", "setPaper", "setSaveUUID"]),
		clear() {
			this.clearPaper();
			this.clearSaveUUID();
		},
	},
};
</script>

<style scoped lang="scss">
.col {
	flex-grow: 0;
}
</style>
